import { ReactElement } from 'react';
import clsx from 'clsx';

type ButtonInfo = {
  id: string;
  name: string;
  icon?: string;
};

type MultiTabProps = {
  buttons: ButtonInfo[];
  size?: 'sm' | 'md' | 'lg';
  handleClick: (temp: string) => void;
  activeButtons: string[];
  hideButtonTextIfSm?: boolean;
};

/**
 * A Button Group Component which renders the group of Button.
 * @param props - Parameters of a Button Group Component.
 * @returns - ButtonGroup HTML.
 */
export default function MultiTab(props: MultiTabProps): ReactElement {
  const { buttons, size, handleClick, activeButtons, hideButtonTextIfSm = false } = props;

  /**
   * A get Button Classes function will Sets the classes for the button based on the props.
   * @param index - Index of that Button in the Array.
   * @returns - String classes for the button.
   */
  const getButtonClasses = (index: number): string => {
    let buttonClasses = '';

    if (size === 'md') {
      buttonClasses = 'px-4 h-9';
    } else if (size === 'sm') {
      buttonClasses = 'px-2';
    }

    if (index < buttons.length - 1) {
      buttonClasses += ' border-r border-r-gray-400 dark:border-r-gray-700';
    }

    return buttonClasses;
  };

  return (
    // TODO : have to fix spacing Issue here its working but not as per the design.
    <div className="border border-gray-400 dark:border-gray-700  rounded cursor-pointer flex h-fit self-center">
      {buttons.map(({ id, name, icon }, index) => (
        <button
          key={id}
          type="button"
          tabIndex={0}
          onClick={() => handleClick(id)}
          onKeyDown={() => handleClick(id)}
          className={` flex items-center justify-center text-sm font-medium grow hover:text-gray-300 ${getButtonClasses(
            index
          )}
        ${
          activeButtons.includes(id)
            ? 'text-gray-400 dark:text-gray-300'
            : 'text-gray-300 dark:text-gray-400'
        }`}
        >
          {icon ? (
            <span className="material-icons-outlined mr-0 sm:mr-2 z-0 text-lg">{icon}</span>
          ) : (
            ''
          )}

          <span
            className={clsx(
              {
                hidden: hideButtonTextIfSm,
                flex: !hideButtonTextIfSm
              },
              'sm:flex'
            )}
          >
            {name}
          </span>
        </button>
      ))}
    </div>
  );
}
